const productForm = document.querySelector('form.product-form');

const formatCentsToDollars = (cents) => {
  return (cents / 100).toFixed(2);
}
const updatePricePerQty = (updatedPriceNode) => {
  const integerPrice = parseFloat(updatedPriceNode.replace('$','')) * 100;
  const pricePerPieceElem = document.querySelector('.price_per_piece');
  const qtyPerBox = parseInt(pricePerPieceElem.dataset.qtyPerBox);
  if(integerPrice && qtyPerBox){
    const newPrice = formatCentsToDollars(integerPrice / qtyPerBox);
    const formattedNewPrice = window.theme.moneyWithCurrencyFormat.replace('{{amount}}',newPrice);
    return pricePerPieceElem.innerText = formattedNewPrice;
  }
}
//Watch for changes to the price element from the wholesale app so that we can update the price per qty element
const priceElem = document.querySelector('.product-form__info-content .price-list span.price');
const config = { attributes: true, childList: true, subtree: true };

const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if(mutation.target.classList == "price wpd-processed"){
      console.log('mutation target classlist includes wpd-processed')
      if (mutation.type === "childList") {
        const textNode = Array.from(mutation.addedNodes).find((node) => node.nodeName == "#text");
        const updatedPrice = textNode.nodeValue;
        updatePricePerQty(updatedPrice);
      } 
    }
  }
};
const mutObserver = new MutationObserver(callback);
mutObserver.observe(priceElem, config);
//End of mutation observer 
//Begin Performance Observer (to watch for fetch requests that update the product info elements)
function getFetchURLs(list) {
  const fetchRequests = list
    .getEntries()
    .filter((resource) => resource.initiatorType === "fetch" && resource.name.includes(`/products/${window.customVariables.currentProductHandle}`))
    .forEach((resource) => {
      const updatedPriceSpan = productForm.querySelector('.price.wpd-processed');
      const updatedPriceText = Array.from(updatedPriceSpan.childNodes).find((node) => node.nodeName == "#text");
      updatePricePerQty(updatedPriceText.nodeValue);
    });
}

const perfObserver = new PerformanceObserver(getFetchURLs);
perfObserver.observe({ entryTypes: ["resource"] });